/**
 * Main Entry Point
 * Initializes all modules for both detail and listing pages
 */

// Stylesheet (processed by Vite — autoprefixed and minified)
import '../css/styles.css';

// Shared modules
import { initAttribution } from './modules/attribution.js';
import { initDialogs } from './modules/dialogs.js';
import { initTooltips } from './modules/tooltips.js';
import { initHeader } from './modules/header.js';
import { initSidebar } from './modules/sidebar.js';
import { initForms } from './modules/forms.js';
import { initMaps } from './modules/maps.js';
import { initShortlist } from './modules/shortlist.js';
import { initNearbyCardMaps } from './modules/nearby-card-maps.js';
import { initTransport } from './modules/transport.js';
import { initFooter } from './modules/footer.js';
import { initCarousels } from './modules/carousel.js';
import { initMultiSelect } from './modules/multi-select.js';
import { initLocationAutocomplete } from './modules/location-autocomplete.js';
import { initMobileCoverage } from './modules/mobile-coverage.js';
import './modules/cta-analytics.js'; // Self-initialising — no init function needed
import { initTracker } from './modules/tracker.js';

// Detail page modules
import { initGallery } from './modules/gallery.js';
import { initExpandableAmenities, initAreaExpander, initNearbyAmenities, initTransportDistanceParsing, initGuideIntro } from './modules/detail-features.js';

// Listing page modules
import { initListingSearch, initSearchDialog, initListingCardLinks, initCountryDetection, initListingSchema, initListingTypeHeading, initListingIntro } from './modules/listing-features.js';
import { initInfiniteScroll } from './modules/infinite-scroll.js';

// Chatbot
import { initChatbot } from './modules/chatbot.js';

// Partner login (dummy dialog in global wrapper)
import { initPartnerLogin } from './modules/partner-login.js';

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
    // Each init wrapped so one failure doesn't block the rest
    const inits = [
        ['attribution', initAttribution],
        ['dialogs', initDialogs],
        ['tooltips', initTooltips],
        ['header', initHeader],
        ['gallery', initGallery],
        ['sidebar', initSidebar],
        ['forms', initForms],
        ['maps', initMaps],
        ['shortlist', initShortlist],
        ['amenities', initExpandableAmenities],
        ['transport', initTransport],
        ['transport-distance', initTransportDistanceParsing],
        ['area-expander', initAreaExpander],
        ['guide-intro', initGuideIntro],
        ['nearby-amenities', initNearbyAmenities],
        ['nearby-card-maps', initNearbyCardMaps],
        ['listing-search', initListingSearch],
        ['search-dialog', initSearchDialog],
        ['listing-card-links', initListingCardLinks],
        ['country-detection', initCountryDetection],
        ['listing-schema', initListingSchema],
        ['listing-type-heading', initListingTypeHeading],
        ['listing-intro', initListingIntro],
        ['infinite-scroll', initInfiniteScroll],
        ['footer', initFooter],
        ['carousels', initCarousels],
        ['multi-select', initMultiSelect],
        ['location-autocomplete', initLocationAutocomplete],
        ['mobile-coverage', initMobileCoverage],
        ['chatbot', initChatbot],
        ['tracker', initTracker],
        ['partner-login', initPartnerLogin],
    ];

    for (const [name, fn] of inits) {
        try { fn(); }
        catch (e) { console.warn(`[${name}] init failed:`, e); }
    }
});
